import { http } from '@/lib/http'
import { profileApi } from '@/features/account/profile.api'

export const viewCountryApi = {
  /** GET /profile/countries → ISO2 codes the switch offers: own country, every country with a record, and the current view. */
  countries: (): Promise<string[]> =>
    http.get<{ countries?: string[] | null } | null>('/profile/countries').then((r) => (r?.countries ?? []).map((c) => c.trim().toUpperCase()).filter(Boolean)),
  /** PUT /profile { viewCountry } — persisted server-side; 400 `viewCountry is invalid` for an unknown code. */
  save: (iso2: string) => profileApi.update({ viewCountry: iso2 }),
}
